import { Controller } from "@hotwired/stimulus";
import CreditCardInputMask from "credit-card-input-mask";

// Connects to data-controller="card-details"
export default class extends Controller {
  static targets = ["number", "expiry", "cvc"];

  connect() {
    if (this.hasNumberTarget) {
      new CreditCardInputMask({
        element: this.numberTarget,
        pattern: "{{9999}} {{9999}} {{9999}} {{9999}}",
      });
    }

    if (this.hasExpiryTarget) this.setupExpiryMask(this.expiryTarget);
    if (this.hasCvcTarget) this.setupCvcMask(this.cvcTarget);
  }

  setupExpiryMask(input) {
    input.addEventListener("input", (e) => {
      let value = e.target.value.replace(/\D/g, "");
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      e.target.value = value.slice(0, 5);
    });
  }

  setupCvcMask(input) {
    input.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4);
    });
  }
}
